module.exports = {
  eventCategory: 'Editor UI | Tool Menu | logos',

  show: { eventAction: 'show' }
};
